import { defaultLocale, intlTag, type Locale } from "@/i18n/config";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
export function formatHora(fecha: string): string {
  const date = new Date(fecha);
  const horas = date.getHours().toString().padStart(2, "0");
  const minutos = date.getMinutes().toString().padStart(2, "0");
  return `${horas}:${minutos}`;
}
export function formatHora12h(fecha: string): string {
  const date = new Date(fecha);
  let horas = date.getHours();
  const minutos = date.getMinutes().toString().padStart(2, "0");
  const ampm = horas >= 12 ? "PM" : "AM";
  horas = horas % 12 || 12;
  return `${horas}:${minutos} ${ampm}`;
}

export function formatFecha(
  fecha: string,
  locale: Locale = defaultLocale,
): string {
  const date = new Date(fecha);
  const opcionesFecha: Intl.DateTimeFormatOptions = {
    day: "numeric",
    month: "long",
  };
  return date.toLocaleDateString(intlTag(locale), opcionesFecha);
}
